import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { seleccionarPagina } from "../../../features/ui/uiSlice";

export const GenerarCertificadoScreen = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(seleccionarPagina("p-generar-certificado"));
  }, [0]);
  return <h1>Generar Certificado</h1>;
};
